import React from 'react';
import {Redirect, Link} from 'react-router-dom';
import {SortableElement} from "react-sortable-hoc";
import {connect} from 'react-redux';
import CountUp from 'react-countup';
import PropTypes from "prop-types";
import ChapterPartEditForm from "./ChapterPartEditForm";
import api from '../../utils/api';
import moment from 'moment';
import thumbshot from '../../assets/videoImgs/thumbshot1.jpg';
import * as CoursesActions from '../../store/actions/coursesActions';

class SortableItem extends React.Component {

    componentDidMount(){
        const {item} = this.props;
        this.props.getVideoQuestionCount(item.id, item.subjectChapterId, item.subjectId, this.props.user.id);
        this.props.getQuizQuestionCount(item.id, item.subjectChapterId, item.subjectId, this.props.user.id);
    }
    
    render(){
        let { item, index, number, showModalDelete, setSelectedEditChapterPartId, selectedEditChapterPartId, redirect, user, updateChapterPartStatus, history } = this.props;
        let questionCount = 0;
        if(item.type === "test"){
            item.sections.map(s => {
                questionCount += s.questions.length;
            })
            // console.log("QuestionCount", questionCount);
        }

        return (
            <div
                id={"panel_chapter_part_"+number+"_"+index}
                className="chapter-part"
            >

                {item.type === "test" ?
                
                <div className="row no-margin">
                    <div className="col-sm-5 no-padding">
                        <div
                            style={{borderBottom: "1px solid #444"}}
                        >
                            <div className="chapter_info">
                                <div className="chapter_thumb">
                                    
                                        <img src={thumbshot} />
                                    
                                </div>
                                <div className="chapter_desc">
                                    <h3 className="font-18 sm-top0">
                                        
                                            {item.title || item.name}
                                        
                                    </h3>
                                    <div className="chapter_controls">
                                        <div className="font-16">
                                            <button
                                                className="zmdi zmdi-edit text-dark chapter-btns hidden"
                                                // onClick="GetEditAbleChapterInfo(this)"
                                                onClick={()=>{setSelectedEditChapterPartId(item.id)}}
                                            />
                                            <button
                                                className="zmdi zmdi-delete text-danger chapter-btns"
                                                onClick={()=>showModalDelete(item.id)}
                                            >
                                            </button>
                                            <Link
                                                to={'/tests/' + item.id}
                                                className="zmdi zmdi-edit text-dark chapter-btns"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    history.push('/tests/' + item.id);
                                                }}
                                                // onClick="GetEditAbleChapterInfo(this)"
                                            />
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.location.href = '/subject-test/' + item.id
                                                }}
                                                className="zmdi zmdi-arrow-right text-dark chapter-btns"
                                                // onClick="GetEditAbleChapterInfo(this)"
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-7 no-padding">
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Total Time</p>
                                    <h3>
                                        {moment.utc(item.finish*1000).format('HH:mm')}
                                    </h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Sections</p>
                                    <h3>
                                        <CountUp
                                            className="counter"
                                            start={0}
                                            end={item.sections.length}
                                            duration={3.75}
                                        />
                                    </h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Questions</p>
                                    <h3>
                                        <CountUp
                                            className="counter"
                                            start={0}
                                            end={questionCount}
                                            duration={3.75}
                                        />
                                    </h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Status</p>
                                    <h3>
                                        <span>
                                            <select
                                                className="form-control status-select"
                                                defaultValue={item.status}
                                                onChange={(e) => {

                                                    updateChapterPartStatus(item.id, e.target.value);
                                                }}>
                                                <option value="true">Active</option>
                                                <option value="false">Inactive</option>
                                            </select>


                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="row no-margin">
                    <div className="col-sm-5 no-padding">
                        <div
                            style={{borderBottom: "1px solid #444"}}
                        >
                            <div className="chapter_info">
                                <div className="chapter_thumb">
                                    {item.ChapterPartImage ?
                                    
                                        <img src={(item.ChapterPartImage) ? api.makeFileURL(item.ChapterPartImage.tinyUrl ? item.ChapterPartImage.tinyUrl : item.ChapterPartImage.url, user.id) : ''} />
                                    :
                                        item.VideoFile ?
                                            item.VideoFile.length > 0 ?
                                                item.VideoFile[0].xsThumb || item.VideoFile[0].thumbnail ?
                                                    <img src={(item.VideoFile[item.VideoFile.length - 1].thumbnail) ? api.makeFileURL(item.VideoFile[item.VideoFile.length - 1].xsThumb ? item.VideoFile[item.VideoFile.length - 1].xsThumb : item.VideoFile[item.VideoFile.length - 1].thumbnail, user.id) : ''} />
                                                :
                                                <img src={thumbshot} />
                                                
                                            :
                                            <img src={thumbshot} />
                                        : <img src={thumbshot} />
                                    }
                                </div>
                                <div className="chapter_desc">
                                    <h3 className="font-18 sm-top0">
                                        
                                            {item.title}
                                        
                                    </h3>
                                    <div className="chapter_controls">
                                        <div className="font-16">
                                            <button
                                                className="zmdi zmdi-edit text-dark chapter-btns hidden"
                                                // onClick="GetEditAbleChapterInfo(this)"
                                                onClick={()=>{setSelectedEditChapterPartId(item.id)}}
                                            />
                                            <button
                                                className="zmdi zmdi-delete text-danger chapter-btns"
                                                onClick={()=>showModalDelete(item.id)}
                                            >
                                            </button>
                                            <Link
                                                to={'/edit-lecture/' + item.id}
                                                className="zmdi zmdi-edit text-dark chapter-btns"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    history.push('/edit-lecture/' + item.id);
                                                }}
                                                // onClick="GetEditAbleChapterInfo(this)"
                                            />
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.location.href = '/video/item/' + item.id
                                                }}
                                                className="zmdi zmdi-arrow-right text-dark chapter-btns"
                                                // onClick="GetEditAbleChapterInfo(this)"
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-7 no-padding">
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Total Time</p>
                                    <h3>
                                        {moment.utc(item.finish*1000).format('HH:mm')}
                                    </h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Video Questions</p>
                                    <h3>
                                        <CountUp
                                            className="counter"
                                            start={0}
                                            end={item.videoQuestionCount ? item.videoQuestionCount : 0}
                                            duration={3.75}
                                        />
                                    </h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Quiz Questions</p>
                                    <h3>
                                        <CountUp
                                            className="counter"
                                            start={0}
                                            end={item.quizQuestionCount ? item.quizQuestionCount : 0}
                                            duration={3.75}
                                        />
                                    </h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="head-subhead">
                                    <p>Status</p>
                                    <h3>
                                        <span>
                                            <select
                                                className="form-control status-select"
                                                defaultValue={item.status}
                                                onChange={(e) => {

                                                    updateChapterPartStatus(item.id, e.target.value);
                                                }}>
                                                <option value="true">Active</option>
                                                <option value="false">Inactive</option>
                                            </select>


                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
                {
                    item.id === selectedEditChapterPartId &&
                    <ChapterPartEditForm
                        setSelectedEditChapterPartId={setSelectedEditChapterPartId}
                        chapter={item}
                        chapterPartInfo={item}
                    />
                }
            </div>
        )
    }
        
    
}

SortableItem.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number,
    number: PropTypes.number,
    showModalDelete: PropTypes.func.isRequired
};

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
    getVideoQuestionCount: (id, chapterId, subjectId, token) => {
        dispatch(CoursesActions.getVQ(id, chapterId, subjectId, token))
    },
    getQuizQuestionCount: (id, chapterId, subjectId, token) => {
        dispatch(CoursesActions.getQQ(id, chapterId, subjectId, token))
    }
})

export default SortableElement(connect(
    mapStateToProps,
    mapDispatchToProps
)(SortableItem));


// WEBPACK FOOTER //
// ./src/components/AdminPanel/SortableItem.js